import React, { useEffect } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { BeforeAfter } from './components/BeforeAfter';
import { ProductShowcase } from './components/ProductShowcase';
import { ValueStack } from './components/ValueStack';
import { TheScience } from './components/TheScience';
import { DigitalAccessPolicy } from './components/DigitalAccessPolicy';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-green-500/30" data-id="element-0" data-mp="31ctd9lpe1q60">
      <noscript data-id="element-1" data-mp="2wip734ny5m5z">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="2wi5l9cv6edmo" />
      </noscript>
      <AnnouncementBar data-id="element-3" data-mp="3iiweonbohg2p" />
      <main data-id="element-4" data-mp="3ijftvw9y1qd1">
        <Hero data-id="element-5" data-mp="3ihv048vgebg8" />
        <BeforeAfter data-id="element-6" data-mp="3mlj9mx3nbh44" />
        <ProductShowcase data-id="element-7" data-mp="3ml12v6jcxkhy" />
        <ValueStack data-id="element-8" data-mp="3mk868ye44bdj" />
        <TheScience data-id="element-9" data-mp="3mjq3rk0ux0x6" />
        <FAQ data-id="element-10" data-mp="3mj6lu3b7icj5" />
        <DigitalAccessPolicy data-id="element-11" data-mp="3rcj7c4kla37o" />
        <FinalCTA data-id="element-12" data-mp="3rdarmj8qkein" />
      </main>
    </div>;
}